// Account profile
export const LOGOUT = "LOGOUT";

// Customer Loop API
export const FETCH_SUBSCRIPTION = "FETCH_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const LIST_SCHEDULED_ORDERS = "LIST_SCHEDULED_ORDERS";
export const LIST_ORDER_HISTORY = "LIST_ORDER_HISTORY";
export const UPDATE_SHIPPING_ADDRESS = "UPDATE_SHIPPING_ADDRESS";
export const LIST_PAYMENT_METHODS = "LIST_PAYMENT_METHODS";
export const CHANGE_PAYMENT_METHOD = "CHANGE_PAYMENT_METHOD";
export const TOGGLE_SCHEDULED_ORDERS_MODAL = "TOGGLE_SCHEDULED_ORDERS_MODAL";
export const TOGGLE_RESCHEDULE_MODAL = "TOGGLE_RESCHEDULE_MODAL";
export const TOGGLE_SUBS_CART = "TOGGLE_SUBS_CART";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const TOGGLE_UPDATING_SUB_PRODUCT = "TOGGLE_UPDATING_SUB_PRODUCT";
export const TOGGLE_UNAVAILABLE_ITEMS = "TOGGLE_UNAVAILABLE_ITEMS";
export const CHANGE_NEXT_BILLING_DATE = "CHANGE_NEXT_BILLING_DATE";
export const UPDATE_DELIVERY_FREQUENCY = "UPDATE_DELIVERY_FREQUENCY";
export const UPDATE_SUBSCRIPTION_BOX = "UPDATE_SUBSCRIPTION_BOX";
export const UPDATE_REACTIVATION_FLOW = "UPDATE_REACTIVATION_FLOW";

// Subscription Cart
export const EDIT_LINE_ITEM = "EDIT_LINE_ITEM";
export const CREATE_LINE_ITEM = "CREATE_LINE_ITEM";
export const REMOVE_LINE_ITEM = "REMOVE_LINE_ITEM";
export const UPDATE_LINE_TO_CREATE = "UPDATE_LINE_TO_CREATE";
export const TOGGLE_SAVE_LOADING = "TOGGLE_SAVE_LOADING";
export const CLEAR_SUBSCRIPTION_CART = "CLEAR_SUBSCRIPTION_CART";
export const UPDATE_DELIVERY_PRICE = "UPDATE_DELIVERY_PRICE";
export const DISCARD_CHANGES = "DISCARD_CHANGES";
export const TOGGLE_SAVE_POPUP = "TOGGLE_SAVE_POPUP";
export const SET_HIGHLIGHT_BANNER = "SET_HIGHLIGHT_BANNER";